const WritePost = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('文章发布成功（仅演示）');
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px' }}>
      <h1 style={{ color: '#0b0a0aff', marginBottom: 24 }}>发布NBA文章</h1>
      <form onSubmit={handleSubmit} style={{ backgroundColor: '#fff', padding: 24, borderRadius: 8 }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>标题</label>
          <input 
            type="text" 
            required
            style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4 }}
            placeholder="例如：2025赛季湖人夺冠分析"
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>摘要</label>
          <textarea 
            rows={3}
            required
            style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4 }}
            placeholder="简要描述文章内容"
          ></textarea>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, color: '#333' }}>正文</label>
          <textarea 
            rows={10}
            required
            style={{ width: '100%', padding: 8, border: '1px solid #ddd', borderRadius: 4 }}
            placeholder="详细的NBA文章内容"
          ></textarea>
        </div>
        <button 
          type="submit"
          style={{ 
            backgroundColor: '#ed1515ff', 
            color: '#fff', 
            border: 'none', 
            padding: '8px 16px', 
            borderRadius: 4, 
            cursor: 'pointer' 
          }}
        >
          发布文章
        </button>
      </form>
    </div>
  );
};

export default WritePost;